"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubscriptionPaymentMethodUpdatedDonorMockData = exports.buildSubscriptionAmountUpdatedDonorMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const organization_facing_base_1 = require("./organization-facing-base");
const buildSubscriptionDonorBase = ({ organizationName, color, isDarkMode, locale = "en", firstName = "Jane", lastName = "Donor", accountLink = "https://www.zeffy.com/en-US/donor/dashboard", subject = "", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    return {
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        labels: (0, email_templates_1.getEmailLabels)(locale),
        lang: locale,
        isPreview: false,
        subject,
        orgName: organizationName || "Bright Futures Foundation",
        firstName,
        lastName,
        accountLink,
    };
};
const AMOUNT_UPDATED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your recurring donation to Bright Futures Foundation has been updated",
    [locales_1.Locales.FR]: "Votre don récurrent à Bright Futures Foundation a été mis à jour",
    [locales_1.Locales.ES]: "Su donación recurrente a Bright Futures Foundation se ha actualizado",
    [locales_1.Locales.DE]: "Ihre regelmäßige Spende an Bright Futures Foundation wurde aktualisiert",
});
const buildSubscriptionAmountUpdatedDonorMockData = ({ previousAmount = "$25.00", newAmount = "$40.00", ...base }) => ({
    ...buildSubscriptionDonorBase({
        subject: (0, organization_facing_base_1.pickForLocale)(AMOUNT_UPDATED_SUBJECT, base.locale ?? "en"),
        ...base,
    }),
    previousAmount,
    newAmount,
});
exports.buildSubscriptionAmountUpdatedDonorMockData = buildSubscriptionAmountUpdatedDonorMockData;
const PAYMENT_METHOD_UPDATED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your payment method for your recurring donation to Bright Futures Foundation has been updated",
    [locales_1.Locales.FR]: "Le mode de paiement pour votre don récurrent à Bright Futures Foundation a été mis à jour",
    [locales_1.Locales.ES]: "El método de pago de su donación recurrente a Bright Futures Foundation se ha actualizado",
    [locales_1.Locales.DE]: "Die Zahlungsmethode für Ihre regelmäßige Spende an Bright Futures Foundation wurde aktualisiert",
});
const buildSubscriptionPaymentMethodUpdatedDonorMockData = (input) => buildSubscriptionDonorBase({
    subject: (0, organization_facing_base_1.pickForLocale)(PAYMENT_METHOD_UPDATED_SUBJECT, input.locale ?? "en"),
    ...input,
});
exports.buildSubscriptionPaymentMethodUpdatedDonorMockData = buildSubscriptionPaymentMethodUpdatedDonorMockData;
